var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { assertExists } from '@blocksuite/global/utils';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { INLINE_ROOT_ATTR, ZERO_WIDTH_SPACE } from '../consts.js';
import { EmbedGap } from './embed-gap.js';
let VLine = class VLine extends LitElement {
    constructor() {
        super(...arguments);
        this.elements = [];
    }
    get vElements() {
        return Array.from(this.querySelectorAll('v-element'));
    }
    get vTexts() {
        return Array.from(this.querySelectorAll('v-text'));
    }
    get textLength() {
        return this.vElements.reduce((acc, el) => acc + el.delta.insert.length, 0);
    }
    get textContent() {
        return this.vElements.reduce((acc, el) => acc + el.delta.insert, '');
    }
    async getUpdateComplete() {
        const result = await super.getUpdateComplete();
        await Promise.all(this.vElements.map(el => el.updateComplete));
        await Promise.all(this.vTexts.map(el => el.updateComplete));
        return result;
    }
    firstUpdated() {
        this.style.display = 'block';
    }
    render() {
        if (this.elements.length === 0) {
            return html `<div><v-text .str=${ZERO_WIDTH_SPACE}></v-text></div>`;
        }
        if (!this.isConnected)
            return;
        const rootElement = this.closest(`[${INLINE_ROOT_ATTR}]`);
        assertExists(rootElement, 'v-line must be inside a v-root');
        const inlineEditor = rootElement.inlineEditor;
        assertExists(inlineEditor, 'v-line must be inside a v-root with inline-editor');
        const renderElements = this.elements.flatMap(([template, delta], index) => {
            if (inlineEditor.isEmbed(delta)) {
                if (delta.insert.length !== 1) {
                    throw new Error(`The length of embed node should only be 1.
            This seems to be an internal issue with inline editor.
            Please go to https://github.com/toeverything/blocksuite/issues
            to report it.`);
                }
                // we add `EmbedGap` to make cursor can be placed between embed elements
                if (index === 0) {
                    const nextDelta = this.elements[index + 1]?.[1];
                    if (!nextDelta || inlineEditor.isEmbed(nextDelta)) {
                        return [EmbedGap, template, EmbedGap];
                    }
                    else {
                        return [EmbedGap, template];
                    }
                }
                else {
                    const nextDelta = this.elements[index + 1]?.[1];
                    if (!nextDelta || inlineEditor.isEmbed(nextDelta)) {
                        return [template, EmbedGap];
                    }
                    else {
                        return [template];
                    }
                }
            }
            return template;
        });
        // prettier will generate \n and cause unexpected space and line break
        // prettier-ignore
        return html `<div style=${styleMap({
            // this padding is used to make cursor can be placed at the
            // start and end of the line when the first and last element is embed element
            padding: '0 0.5px',
        })}>${renderElements}</div>`;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ attribute: false })
], VLine.prototype, "elements", void 0);
VLine = __decorate([
    customElement('v-line')
], VLine);
export { VLine };
//# sourceMappingURL=v-line.js.map